<template>
   <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="large-panel" @click.stop>
                <div class="dialog-title">
                    <div v-if="editUserList.length == 0" v-t="{ path: 'message.title_add_publish_information_user', args: { information: getUserPublishInformationName(informationType) } }"></div>
                    <div v-else v-t="{ path: 'message.title_edit_publish_information_user', args: { information: getUserPublishInformationName(informationType) } }"></div>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-body">
                    <UserSelection
                        :appData="appData"
                        :title="selectedTitle"
                        :selectedUsers="editUserList"
                        :selectionType="selectionType"
                        @changeSelectedUser="handleChangeSelectedUser()"
                        ref="UserSelection">
                    </UserSelection>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" type="button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" :disabled="this.disableSave" @click="saveUpdatedInfo" v-t="'message.button_save'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import Vue from 'vue'
import server from "./ServerApi.js";
import commonUtil from './commonutil.js';
import constants from './constants.js';
import UserSelection from "./UserSelection.vue"

export default {
    data() {
      return {
          selectedTitle: null,
          selectionType: 0,
          disableSave: true
      };
    },
    methods: {
        handleChangeSelectedUser() {
            this.disableSave = false;
        },
        saveUpdatedInfo() {
            this.$emit('save' , { removeTagList: this.$refs.UserSelection.removeTagList , addTagList: this.$refs.UserSelection.addTagList } );
        },
        getUserPublishInformationName(informationType) {
            return commonUtil.getUserPublishInformationName(this.$i18n, informationType);
        }
    },
    components: {
        UserSelection
    },
    created: function() {
        this.disableSave = true;
        switch(this.informationType) {
            case constants.USER_PUBLISH_INFORMATION_ACCURACY:
                this.selectedTitle = commonUtil.getMessageText(this.$i18n,"title_publish_informations_setting2").replace("{information}",commonUtil.getMessageText(this.$i18n,"item_accuracy"));
                this.selectionType = constants.USER_SELECTION_USER_PUBLISH_INFORMATION;
                break;
            case constants.USER_PUBLISH_INFORMATION_SPEED:
                this.selectedTitle = commonUtil.getMessageText(this.$i18n,"title_publish_informations_setting2").replace("{information}",commonUtil.getMessageText(this.$i18n,"item_speed"));
                this.selectionType = constants.USER_SELECTION_USER_PUBLISH_INFORMATION;
                break;
            case constants.USER_PUBLISH_INFORMATION_DIRECTION:
                this.selectedTitle = commonUtil.getMessageText(this.$i18n,"title_publish_informations_setting2").replace("{information}",commonUtil.getMessageText(this.$i18n,"item_direction"));
                this.selectionType = constants.USER_SELECTION_USER_PUBLISH_INFORMATION;
                break;
            case constants.USER_PUBLISH_INFORMATION_BATTERY:
                this.selectedTitle = commonUtil.getMessageText(this.$i18n,"title_publish_informations_setting2").replace("{information}",commonUtil.getMessageText(this.$i18n,"item_battery"));
                this.selectionType = constants.USER_SELECTION_USER_PUBLISH_INFORMATION;
                break;
        }
    },
    props: [ 'appData', 'informationType' , 'editUserList']
}
</script>


<style scoped>
.dialog-modal-mask {
    position: fixed;
    z-index: 1999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
}

.dialog-input-field {
    height: 60px;
}

.title-box-command-normal {
    font-size: 14px;
    color: #5171cb;
}

.default-message {
    position: relative;
    top: 10%;
    opacity: 0.6;
    text-align: center;
    vertical-align: middle;
}

button.transparent-button {
    border-style: none;
    color: #333B48;
    background-color: transparent;
    cursor: pointer;
    outline: 0;
}

.searched-user {
  padding: 10px;
  padding-left: 29px;
  cursor: pointer;
}
.searched-user:hover {
  background-color: #ecf1fa;
}

.input-with-select >>> .el-input-group__prepend {
    background-color: #fff;
}

.input-with-select >>> .el-select .el-input {
    font-size: 14px;
    width: 120px;
}

.el-input-group {
    width: 650px;
    padding-left: 20px;
    padding-bottom: 0px;
}

.el-select-dropdown__item.selected {
    color: #000000;
}

.el-select-dropdown__item {
    font-size: 14px;
}

.input-with-select >>> .el-button {
    width: 40px;
    padding: 0;
}
</style>
